/**
 * @file tips.js
 */

export const Tip = {
    banned: '您已被禁言处理，如有疑问请咨询客服',
    notLogin: '您的身份已失效，请重新登录',
    vcr: '您输入的内容包含敏感词，请修改后重新提交',
    existNull: '您的信息未完善，请完善后进行提交',
    crashStackContentError: '仅需堆栈文件和堆栈线上地址中任意一项',
    paramsError: '网络出了点问题，请与客服沟通咨询',
    netError: '网络出了点问题，请稍后再试',
    verityError: '验证码输入错误，请重新输入',
    requestError: '请求超时',
    freqOperate: '您的操作太频繁，请稍候再试',
    riskError: '您的账号存在风险，暂无法发帖，详情请咨询客服',
    mkdError: '验证结果错误，请重新操作',
    alreadyExists: '创建失败，iCafe已存在，请刷新查看',
    nonExistent: '创建失败，跟进用户的有效不存在，请联系运营添加',
    aismatch: '创建失败，iCafe字段不匹配，请联系技术同学解决',
    recordError: '创建失败，iCafe创建后记录错误，请联系技术同学解决',
    routineError: '创建失败，请联系技术同学解决',
    pausePosting: '系统升级，暂停发帖。如有问题请单击右下角智能客服咨询',
    suspendReply: '系统升级，暂停回帖。如有问题请单击右下角智能客服咨询',
    postAndReply: '系统升级，暂停发帖和回帖。如有问题请单击右下角智能客服咨询',
    viewRestricted: '当前界面仅发帖人可查看，请确认登录身份'
};

export const errCodeTip = errno => {
    switch (errno) {
        // 敏感词
        case 10020: return Tip.vcr;
        // 访问受限
        case 10008: return Tip.viewRestricted;
        // 验证码错误
        case 43264: return Tip.verityError;
        // 禁言
        case 43231:
        case 43223: return Tip.banned;
        // 登录态失效
        case 12600:
        case 12601: return Tip.notLogin;
        // 参数错误
        case 10005: return Tip.paramsError;
        // 频繁操作
        case 43351: return Tip.freqOperate;
        // 风控管理
        case 43393: return Tip.riskError;
        // 滑动验证失败
        case 43397: return Tip.mkdError;
        case 43401: return Tip.alreadyExists;
        case 43402: return Tip.nonExistent;
        case 43403: return Tip.aismatch;
        case 43404: return Tip.recordError;
        case 43405: return Tip.routineError;
        case 43406: return Tip.pausePosting;
        case 43433: return Tip.suspendReply;
        case 43434: return Tip.postAndReply;
        default: return Tip.netError;
    }
};
